import {BlogTagLocale, PublicBlogPost} from '@yandex-data-ui/cloud-schemas/build/models/ui-api';

import {request} from 'api';
import {LocaleData} from 'contexts/LocaleContext';
import {BlogPagePostsData, GetBlogPostsRequest} from './model';

export function getBlogTags({lang, region}: LocaleData) {
    return request<BlogTagLocale[]>({
        method: 'GET',
        url: '/api/blog/tags',
        params: {lang, region},
    });
}

export function getBlogPosts(
    {lang, region}: LocaleData,
    {tags, sortBy, perPage, page}: GetBlogPostsRequest,
) {
    return request<BlogPagePostsData>({
        method: 'GET',
        url: '/api/blog/posts',
        params: {tags, sortBy, perPage, page, lang, region},
    });
}

export function getBlogPost({lang, region}: LocaleData, url: string) {
    return request<PublicBlogPost>({
        method: 'GET',
        url: `/api/blog/posts/${url}`,
        params: {lang, region},
    });
}

export function addBlogPostLike(postId: number) {
    return request<PublicBlogPost>({
        method: 'POST',
        url: `/api/blog/posts/${postId}/addLike`,
    });
}

export function removeBlogPostLike(postId: number) {
    return request<PublicBlogPost>({
        method: 'POST',
        url: `/api/blog/posts/${postId}/removeLike`,
    });
}

export function getBlogPostsByService({lang, region}: LocaleData, serviceId?: number) {
    return request<PublicBlogPost[]>({
        method: 'GET',
        url: '/api/blog/posts-preview',
        params: {lang, region, serviceIds: serviceId ? [serviceId] : undefined},
    });
}
